/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useEffect, useState } from 'react';
import { SingleValue } from 'react-select';
import { FormGroup, Label } from 'reactstrap';
import { QUESTION } from '@constants/terminology';
import { Option, SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { QuestionStatusStats, StatusOption } from '../../../types/initiativeStats';

interface UserSelectFieldProps {
  label?: string;
  onChange: (value: QuestionStatusStats) => void;
  options: StatusOption[];
  defaultSelection?: QuestionStatusStats;
}

export const QuestionsFilter = (props: UserSelectFieldProps) => {
  const { label = 'To', onChange, options, defaultSelection = 'created' } = props;


  const [selectedStatus, setSelectedStatus] = useState<StatusOption | null>(null);

  useEffect(() => {
    onChange(defaultSelection);
    setSelectedStatus(options.find((option) => option.value === defaultSelection) || null);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  const handleOnchange = (selection: SingleValue<Option<QuestionStatusStats> | null>) => {
    const selectedOption = options.find(option => option.value === selection?.value);
    if (!selectedOption || !selection) {
      return;
    }
    onChange(selection.value);
    setSelectedStatus(selectedOption);
  }

  return (
    <FormGroup>
      <Label for={QUESTION.PLURAL}>{label}</Label>
      <SelectFactory<QuestionStatusStats>
        selectType={SelectTypes.SingleSelect}
        isSearchable={false}
        options={options}
        noOptionsMessage={() => 'No options available for selection'}
        value={selectedStatus ?? null}
        onChange={handleOnchange}
      />
    </FormGroup>
  );
}
